module.exports = __webpack_public_path__ + "static/media/ic_ruzhu_marketing@2x.20a1bfe9.png";